// useLoginForm.js
import { useAuthStore } from "@/stores/authStore";
import { useRouter } from "vue-router";
import { ref, unref } from "vue";
import { toast } from "@/utils/toast";

export function useLoginForm() {
  const auth = useAuthStore();
  const router = useRouter();
  const loading = ref(false);

  const submit = async (values) => {
    loading.value = true;
    try {
      await auth.login(values);

      // Normalize roles safely
      const rolesRaw = unref(auth.roles);
      const rolesArr = Array.isArray(rolesRaw) ? rolesRaw : [];
      const rolesLC = rolesArr.map(r => String(r).toLowerCase());

      // Redirect: prefer Employee over Admin (swap order if you want admin-first)
      if (auth.isSuperAdmin) {
        await router.push("/super-admin/dashboard");
      } else if (rolesLC.includes("employee")) {
        await router.push("/dashboard/employee-dashboard");
      } else if (rolesLC.includes("admin")) {
        await router.push("/dashboard/admin-dashboard");
      } else {
        await router.push("/dashboard");
      }

      toast("Login successful");
    } catch {
      // errors are already toasted in the store
    } finally {
      loading.value = false;
    }
  };

  return { submit, loading };
}
